module.exports = __webpack_public_path__ + "img/EE10237832.8f656b0a.png";